// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_y-2";
export var blackBorderOnHover = "_y-7";
export var cell = "_y-6";
export var cellContainer = "_y-3";
export var checked = "_y-8";
export var disabled = "_y-5";
export var featuredIconCellContainer = "_y-9";
export var featuredIconTextContainer = "_y-b";
export var featuredIconWrapper = "_y-a";
export var noBorder = "_y-c";
export var orangeSelectedRow = "_3a-3";
export var overflowableText = "_y-0";
export var overflowableTextContainer = "_y-1";
export var row = "_x-0";
export var rowCheckboxCell = "_y-4";
export var selectableTable = "_3a-2";